// =============================================================================
// ClientRow
//
// A single row in the client management table.
// Exposes action buttons for triggering MAP, repairing, and re-onboarding.
// =============================================================================

import { FunctionComponent } from "react";
import { CLIENT_MANAGEMENT } from "src/constants/adminDashboard";
import { Client } from "src/utils/types/UserTypes";

interface ClientRowProps {
  client: Client;
  onTriggerMap: (client: Client) => void;
  onReOnboard: (client: Client) => void;
  onRepair: (client: Client) => void;
}

const ClientRow: FunctionComponent<ClientRowProps> = ({
  client,
  onTriggerMap,
  onReOnboard,
  onRepair,
}) => (
  <tr className="border-b border-gray-100 hover:bg-gray-50">
    <td className="py-3 px-4 text-sm text-gray-800">{client.userInfo.name}</td>
    <td className="py-3 px-4 text-sm text-gray-500">{client.userInfo.email}</td>
    <td className="py-3 px-4 text-sm text-gray-500">{client.userId}</td>
    <td className="py-3 px-4">
      <div className="flex gap-2">
        <button
          onClick={() => onTriggerMap(client)}
          className="px-3 py-1 text-xs text-white bg-primary rounded hover:opacity-90"
        >
          {CLIENT_MANAGEMENT.actions.triggerMap}
        </button>
        <button
          onClick={() => onRepair(client)}
          className="px-3 py-1 text-xs text-white bg-primary rounded hover:opacity-90"
        >
          {CLIENT_MANAGEMENT.actions.repair}
        </button>
        <button
          onClick={() => onReOnboard(client)}
          className="px-3 py-1 text-xs text-white bg-red-600 rounded hover:opacity-90"
        >
          {CLIENT_MANAGEMENT.actions.reOnboard}
        </button>
      </div>
    </td>
  </tr>
);

export default ClientRow;

